import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./assets/styles/style.scss";
import "./assets/styles/normilize.css";
import { BrowserRouter } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { register } from "swiper/element/bundle";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toast } from "@components";
import { initializeStores } from "./stores/init";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/browser";

Sentry.init({
    dsn: "https://2fa76b34edf0c77fbd75fe82b6464253@o4509386315726848.ingest.de.sentry.io/4509386317824080",
    sendDefaultPii: true,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,

    environment: process.env.NODE_ENV,
});

register();
const queryClient = new QueryClient();

initializeStores();

const manifestUrl = "https://raw.githubusercontent.com/nestdex/tonconnect-manifest/master/tonconnect-manifest.json";

createRoot(document.getElementById("root")!).render(
    <TonConnectUIProvider manifestUrl={manifestUrl}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Toast />
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </TonConnectUIProvider>,
);
